var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLink(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "#28673C"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.1989 17.6392C15.6415 19.5072 18.3745 19.8892 20.3031 18.4919C20.4701 18.3704 20.6283 18.2381 20.7753 18.0957L22.7758 16.1582C24.4493 14.4803 24.4008 11.8064 22.6685 10.1855C20.9786 8.60483 18.2993 8.60483 16.6085 10.1855M17.801 14.3602C16.3585 12.4922 13.6255 12.1102 11.6969 13.5075C11.53 13.6289 11.3717 13.7613 11.2247 13.9037L9.22423 15.8412C7.55072 17.5191 7.59916 20.193 9.33147 21.8139C11.0214 23.3954 13.7008 23.3954 15.3916 21.8139",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLink);
export default __webpack_public_path__ + "static/media/link.dedc4c2d866af05b03dd0bf22c0e78fe.svg";
export { ForwardRef as ReactComponent };